exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".txt-blue[_v-42f3433c]{color:#00e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-42f3433c&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/provider/list.vue
// module id = 355
// module chunks = 0